(() => {
  const json = JSON.parse(
    document.getElementById("navigation-data").textContent
  );

  // Utility function to check if any descendant link is active (exakter Match!)
  function isAnyDescendantActive(links) {
    if (!links || links.length === 0) return false;

    const currentPath = window.location.pathname.replace(/\/$/, ""); // Trailing slash entfernen

    return links.some(
      (link) => {
        const linkPath = link.url.replace(/\/$/, "");
        return (
          linkPath === currentPath || // exakter Vergleich
          isAnyDescendantActive(link.links)
        );
      }
    );
  }

  // Utility function to check if URL matches current page exactly
  function isCurrentPageUrl(url) {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const linkPath = url.replace(/\/$/, "");
    return currentPath === linkPath;
  }

  const buildSideNav = () => {
    const sideNavContainer = document.querySelector(".collection__nav-wrapper");
    if (!sideNavContainer) return;

    // Create the main navigation container
    const navContainer = document.createElement("div");
    navContainer.className = "collection__navigation";

    // Build the navigation structure recursively
    const buildNavItems = (items, parentElement) => {
      items.forEach((item) => {
        const isDescendantActive = isAnyDescendantActive(item.links);
        const isCurrentPage = isCurrentPageUrl(item.url);

        if (item.level !== "1" || isDescendantActive || isCurrentPage) {
          // Create link
          const link = document.createElement("a");
          link.href = item.url;
          link.textContent = item.title;

          // Determine class based on level
          if (item.level === "1") {
  link.className = "collection__navigation-level-1";
} else if (item.level === "2") {
  link.className = "collection__navigation-level-2";
} else if (item.level === "3") {
  link.className = "collection__navigation-level-3";
} else if (item.level === "4") {
  link.className = "collection__navigation-level-4";
} else if (item.level === "5") {
  link.className = "collection__navigation-level-5";
}

          // Add active class if current URL matches item URL exactly
          if (isCurrentPage) {
            link.classList.add("collection__navigation-current-link");
          }

          // Add link to parent element
          parentElement.appendChild(link);

          // If item has children, recursively build child items
          if (item.links && item.links.length > 0) {
            const shouldShowChildren =
              isCurrentPageUrl(item.url) || isAnyDescendantActive(item.links);

            // Only show child items if this path is active
            if (shouldShowChildren) {
              buildNavItems(item.links, parentElement);
            }
          }
        }
      });
    };

    // Initialize the navigation
    buildNavItems(json, navContainer);
    sideNavContainer.appendChild(navContainer);
  };

  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", buildSideNav);
})();

